import React, {useCallback} from 'react';
import {useMatch, useNavigate} from 'react-router-dom';

import {StyledListItemIcon, StyledListItemText, StyledNavLink} from '../styles';

interface NavLinkProps {
	to: string;
	Icon: React.ElementType;
	size: string;
	text: string;
	expand: boolean;
}

/**
 * NavLink component.
 * @param {Object} props - Component props.
 * @param {string} props.to - The path that the NavLink points to.
 * @param {Function} props.Icon - The icon component to display.
 * @param {string} props.size - The size of the icon.
 * @param {string} props.text - The text to display.
 * @param {boolean} props.expand - Whether to expand the NavLink.
 * @return {JSX.Element} The rendered NavLink component.
 */
const NavLink: React.FC<NavLinkProps> = ({to, Icon, size, text, expand}) => {
	// Highlight for every page in the section (e.g. '/BMO/cases' -> '/BMO/*'), not only the exact link target.
	const match = useMatch({path: `/${to.split('/')[1]}`, end: false});
	const navigate = useNavigate();
	const handleOnClick = useCallback(() => {
		navigate(to);
	}, [navigate, to]);
	return (
		<StyledNavLink
			to={to}
			className={match ? 'active' : ''}
			onClick={handleOnClick}
		>
			<StyledListItemIcon>
				<Icon size={size} $isActive={match ? true : false} />
			</StyledListItemIcon>
			{expand && (
				<StyledListItemText>{text}</StyledListItemText>
			)}
		</StyledNavLink>
	);
}

export default NavLink;
